import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/** Uyni va chaqmoqni chizadigan animatsiyali SVG (tashqi rasm yo'q: tez va yengil). */
export function HeroArt({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 320 260" className={cn("w-full", className)} aria-hidden="true">
      <defs>
        <linearGradient id="roof" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0.95" />
          <stop offset="1" stopColor="#dcd7ff" stopOpacity="0.9" />
        </linearGradient>
        <linearGradient id="bolt" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#ffe08a" />
          <stop offset="1" stopColor="#ffb020" />
        </linearGradient>
      </defs>
      {/* tarmoq chiziqlari */}
      <g fill="none" stroke="#ffffff" strokeOpacity="0.55" strokeWidth="2" strokeLinecap="round">
        <path className="anim-flow" d="M40 210 H120 V180" />
        <path className="anim-flow" d="M280 70 H230 V110" />
        <path className="anim-flow" d="M60 90 H110 V130" />
      </g>
      {[
        [40, 210],
        [280, 70],
        [60, 90],
      ].map(([x, y], i) => (
        <circle
          key={i}
          cx={x}
          cy={y}
          r="5"
          fill="#ffe08a"
          className="anim-spark"
          style={{ ["--i" as string]: i }}
        />
      ))}
      <g className="anim-float" style={{ transformOrigin: "160px 130px" }}>
        {/* uy */}
        <path
          d="M70 128 L160 52 L250 128 V212 a10 10 0 0 1 -10 10 H80 a10 10 0 0 1 -10 -10 Z"
          fill="url(#roof)"
        />
        <rect x="136" y="150" width="48" height="72" rx="8" fill="#5b4bff" fillOpacity="0.85" />
        <rect x="92" y="146" width="30" height="30" rx="6" fill="#8b5cf6" fillOpacity="0.55" />
        <rect x="198" y="146" width="30" height="30" rx="6" fill="#8b5cf6" fillOpacity="0.55" />
        {/* chaqmoq */}
        <path
          d="M172 22 L132 92 h28 l-12 52 l52 -76 h-30 l16 -46 Z"
          fill="url(#bolt)"
          stroke="#ffffff"
          strokeOpacity="0.7"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

/** Katta gradient banner: salom, qisqa matn, harakat tugmalari va animatsiyali rasm. */
export function Hero({
  title,
  subtitle,
  actions,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "hero-gradient shadow-pop relative isolate overflow-hidden rounded-3xl p-5 text-white sm:p-8",
        className,
      )}
    >
      <div className="anim-drift pointer-events-none absolute -right-16 -top-20 -z-10 size-64 rounded-full bg-white/15 blur-2xl" />
      <div
        className="anim-drift pointer-events-none absolute -bottom-24 left-1/3 -z-10 size-56 rounded-full bg-fuchsia-400/25 blur-2xl"
        style={{ animationDelay: "-4s" }}
      />
      <div className="grid items-center gap-4 sm:grid-cols-[1fr_16rem]">
        <div className="anim-fade-up">
          <h1 className="text-2xl font-extrabold leading-tight tracking-tight sm:text-4xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 max-w-xl text-sm text-white/85 sm:text-base">{subtitle}</p>
          )}
          {actions && <div className="mt-5 flex flex-wrap gap-2">{actions}</div>}
        </div>
        <div className="anim-pop mx-auto hidden w-56 sm:block" style={{ ["--i" as string]: 2 }}>
          <HeroArt />
        </div>
      </div>
    </section>
  );
}
